import { Link } from 'react-router-dom';
// Not: Alias (@) kullanımı bazen derleme hatası verebilir, garanti olması için relative path kullanıyoruz.
// Eğer resim yüklenmezse diye fallback bir yapı da ekledim.
import headerImage from '../assets/images/header.png';

// --- INLINE ICONS (Hatasız ve Hızlı) ---
const Icons = {
  Rocket: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
    </svg>
  ),
  Lightbulb: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-1 1.5-2 1.5-3.5 0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.5.5 2.5 1.5 3.5.8.8 1.3 1.5 1.5 2.5" />
      <path d="M9 18h6" />
      <path d="M10 22h4" />
    </svg>
  ),
  Palette: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="13.5" cy="6.5" r=".5" />
      <circle cx="17.5" cy="10.5" r=".5" />
      <circle cx="8.5" cy="7.5" r=".5" />
      <circle cx="6.5" cy="12.5" r=".5" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
    </svg>
  ),
  Gamepad: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <line x1="6" y1="12" x2="10" y2="12" />
      <line x1="8" y1="10" x2="8" y2="14" />
      <line x1="15" y1="13" x2="15.01" y2="13" />
      <line x1="18" y1="11" x2="18.01" y2="11" />
      <rect x="2" y="6" width="20" height="12" rx="2" />
    </svg>
  ),
  Book: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  Star: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Play: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" className={className}>
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),
  ChevronRight: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  )
};

export const Home = () => {
  return (
    <div className="min-h-screen bg-[#FDFDFC] overflow-x-hidden font-sans">

      {/* --- HERO SECTION --- */}
      <section className="relative pt-12 pb-20 lg:pt-20 lg:pb-32 overflow-hidden">
        {/* Animated Background Blobs */}
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-orange-200/40 rounded-full blur-[100px] animate-pulse" />
        <div className="absolute bottom-[10%] left-[-10%] w-[400px] h-[400px] bg-blue-200/40 rounded-full blur-[100px]" />

        <div className="container mx-auto px-4 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

            {/* Left Content */}
            <div className="text-center lg:text-left space-y-8">
              <div className="inline-flex items-center gap-2 bg-white border border-purple-100 shadow-sm rounded-full px-4 py-1.5 transform hover:scale-105 transition-transform cursor-default">
                <span className="flex h-2 w-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-sm font-bold text-gray-600 tracking-wide">YENİ MACERA BAŞLADI</span>
              </div>

              <h1 className="text-5xl lg:text-7xl font-black text-gray-900 tracking-tight leading-[1.1]">
                Hayal Et, <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600">
                  Yarat, Keşfet!
                </span> 🚀
              </h1>

              <p className="text-xl text-gray-600 font-medium leading-relaxed max-w-lg mx-auto lg:mx-0">
                Mucittin ile öğrenmek artık sıkıcı değil! Oyunlar, hikayeler ve çılgın projelerle dolu bir dünyaya hoş geldin.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-2">
                <Link to="/play" className="group relative bg-gray-900 hover:bg-orange-500 text-white font-bold text-lg px-8 py-4 rounded-full shadow-xl hover:shadow-orange-500/30 transition-all duration-300 transform hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-3">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-colors">
                    <Icons.Play className="w-4 h-4 text-white" />
                  </div>
                  <span>Hemen Başla</span>
                </Link>
                <Link to="/about" className="group bg-white border-2 border-gray-100 hover:border-orange-200 text-gray-600 hover:text-orange-600 font-bold text-lg px-8 py-4 rounded-full hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2">
                  <span>Daha Fazla</span>
                  <Icons.ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative group perspective-1000">
              <div className="absolute inset-4 bg-gradient-to-tr from-purple-400 to-orange-400 rounded-[2.5rem] blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-500" />

              <img
                src={headerImage}
                alt="Mucittin ve Arkadaşları"
                className="relative w-full rounded-[2.5rem] shadow-2xl border-4 border-white transform transition-transform duration-500 group-hover:rotate-1 group-hover:scale-[1.02]"
                onError={(e) => {
                  // Eğer yerel resim yüklenemezse (path hatası vs), placeholder göster.
                  e.currentTarget.src = "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80";
                }}
              />

              {/* Floating Badge - Sağ Alt */}
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 animate-bounce" style={{ animationDuration: '3s' }}>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-600">
                    <Icons.Star className="w-6 h-6" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-bold uppercase">Kullanıcı Puanı</p>
                    <p className="text-lg font-black text-gray-900">4.9/5</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* --- FEATURES SECTION (Bento Style) --- */}
      <section className="container mx-auto px-4 py-20">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            Neler Yapabilirsin? <span className="text-orange-500">🌟</span>
          </h2>
          <p className="text-xl text-gray-600">
            Sadece izlemek yok! Burada parçaları birleştirir, boyar ve kendi dünyanı yaratırsın.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="group bg-gradient-to-b from-purple-50 to-white border border-purple-100 rounded-[2rem] p-8 hover:shadow-2xl hover:shadow-purple-200/50 transition-all duration-300 hover:-translate-y-2">
            <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-transform">
              <Icons.Rocket className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-purple-600 transition-colors">Hızlı Öğren</h3>
            <p className="text-gray-600 leading-relaxed">
              Oyunlaştırılmış derslerle sıkılmadan, roket hızıyla yeni bilgiler öğren.
            </p>
          </div>

          {/* Card 2 */}
          <div className="group bg-gradient-to-b from-pink-50 to-white border border-pink-100 rounded-[2rem] p-8 hover:shadow-2xl hover:shadow-pink-200/50 transition-all duration-300 hover:-translate-y-2 relative md:-mt-8">
            <div className="absolute -top-4 -right-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">POPÜLER</div>
            <div className="w-16 h-16 bg-pink-100 text-pink-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:-rotate-6 transition-transform">
              <Icons.Palette className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-pink-600 transition-colors">Sanatını Konuştur</h3>
            <p className="text-gray-600 leading-relaxed">
              Dijital boyama kitapları ve çizim araçlarıyla içindeki sanatçıyı ortaya çıkar.
            </p>
          </div>

          {/* Card 3 */}
          <div className="group bg-gradient-to-b from-orange-50 to-white border border-orange-100 rounded-[2rem] p-8 hover:shadow-2xl hover:shadow-orange-200/50 transition-all duration-300 hover:-translate-y-2">
            <div className="w-16 h-16 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-transform">
              <Icons.Lightbulb className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">İcat Çıkar</h3>
            <p className="text-gray-600 leading-relaxed">
              "Eski köye yeni adet" getir! Kendi projelerini tasarla ve arkadaşlarınla paylaş.
            </p>
          </div>
        </div>
      </section>

      {/* --- ACTIVITIES SECTION (Dark/Contrast Theme) --- */}
      <section className="bg-[#0F1C2E] py-24 relative overflow-hidden">
        {/* Background Patterns */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10" style={{ backgroundImage: 'radial-gradient(#4b5563 1px, transparent 1px)', backgroundSize: '32px 32px' }}></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
            <div className="max-w-xl">
              <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
                Favori Aktiviteler 🎮
              </h2>
              <p className="text-xl text-gray-400">
                Binlerce çocuk şu an bu oyunlarla eğleniyor. Sen de katıl!
              </p>
            </div>
            <button className="text-white border border-gray-600 hover:border-white hover:bg-white/10 px-6 py-3 rounded-full font-bold transition-all">
              Tümünü Gör
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: Icons.Gamepad, title: 'Kodlama Oyunu', desc: 'Algoritma mantığını oyunla çöz.', color: 'text-blue-400', bg: 'bg-blue-400/10' },
              { icon: Icons.Book, title: 'Sesli Hikayeler', desc: 'Uyku öncesi maceraları dinle.', color: 'text-purple-400', bg: 'bg-purple-400/10' },
              { icon: Icons.Star, title: 'Rozet Koleksiyonu', desc: 'Görevleri tamamla, rütbeni yükselt.', color: 'text-yellow-400', bg: 'bg-yellow-400/10' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all cursor-pointer group">
                <div className={`w-12 h-12 ${item.bg} ${item.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <item.icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- CTA SECTION --- */}
      <section className="container mx-auto px-4 py-24">
        <div className="bg-gradient-to-r from-orange-400 to-pink-500 rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden shadow-2xl shadow-orange-500/20">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>

          <div className="relative z-10 max-w-3xl mx-auto space-y-8">
            <h2 className="text-4xl md:text-6xl font-black text-white leading-tight">
              Hadi, İçindeki Mucidi Uyandır! 🌈
            </h2>
            <p className="text-xl text-white/90 font-medium">
              Ücretsiz üye ol, karakterini oluştur ve Harika İcatlar Ormanı'na ilk adımını at.
            </p>
            <button className="bg-white text-orange-600 hover:bg-orange-50 font-bold text-xl px-12 py-5 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all">
              🎉 Ücretsiz Kayıt Ol
            </button>
            <p className="text-white/60 text-sm">Kredi kartı gerekmez • İptal edilebilir</p>
          </div>
        </div>
      </section>

    </div>
  );
};